import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GhanaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14824'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14824)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#E71F37'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#118B56'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#FDD64C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 8.12821L8.6006 9.12106L9.13167 7.50988L7.73567 6.51232L9.46338 6.50941L10.0001 4.90002L10.5368 6.50941L12.2645 6.51232L10.8685 7.50988L11.3996 9.12106L10.0001 8.12821Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default GhanaFlagIcon;
